import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'flow-dropdown-button',
  template: `
  <flow-button theme="primary" variation="fill" [isCapitalize]="false" [matMenuTriggerFor]="menu">
    <span>{{title}}</span>
    <mat-icon>arrow_drop_down</mat-icon>
  </flow-button>
  <mat-menu #menu="matMenu">
    <ng-content></ng-content>
  </mat-menu>
`,
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatMenuModule, MatIconModule, ButtonComponent], 
})
export class DropdownButtonComponent {
  @Input() title!: string;
}
